import React, { ReactNode, useContext, useState } from "react"
import { HttpStatusCode } from "axios";
import { Button, Flex, Spin, Divider, Tooltip, Checkbox } from "antd"

import { ContextInscricao } from "../InscricaoDaViagem"
import { useObterHTMLDaFichaDeAutorizacaoDoAluno } from "@/Services/Domain/Documentos/DocumentoService";
import { VisualizarDocumentoHTML } from "@/Documentos/VisualizarDocumentoHTML";

export const AutorizacaoDaViagem: React.FC<{
    onSucesso?:() => void;
    onCancelar?:() => void;
    textoSalvar?:ReactNode;
    textoCancelar?:ReactNode;
}> = (props) => {

    const textoSalvar = props.textoSalvar ?? "Salvar";
    const textoCancelar = props.textoCancelar ?? "Cancelar";

    const { inscricao } = useContext(ContextInscricao);

    const [concordou, setConcordou] = useState<boolean>(false);

    const fichaDeAutorizacaoQuery = useObterHTMLDaFichaDeAutorizacaoDoAluno({ enabled: true }, [
        { 
                codigoDoAluno: inscricao.aluno?.codigo!,
                codigoDaViagem: inscricao.viagem?.codigo!,
        },
        {
            doNotNotify: (err) => err.response?.status === HttpStatusCode.NotFound 
        }
    ]);

    const estaProcurandoDocumentos = fichaDeAutorizacaoQuery.isFetching;

    if (fichaDeAutorizacaoQuery.isFetching)
        return <Flex justify="center" align="middle"><Spin tip={"Carregando..."} size="large"></Spin></Flex>;

    return (
        <>
            {fichaDeAutorizacaoQuery.data?.data && (
                <React.Fragment>
                    <VisualizarDocumentoHTML html={fichaDeAutorizacaoQuery.data.data} />

                    <Divider />

                    <Checkbox checked={concordou} onClick={() => setConcordou(!concordou)}>
                        Concordo em imprimir, preencher e entregar uma cópia preenchida do formulário acima à coordenação da escola
                    </Checkbox>

                    <Divider />

                    <Flex justify="start" gap={8}>
                        <Button type="primary" danger htmlType="button" onClick={() => props.onCancelar?.()}>
                            {textoCancelar}
                        </Button>

                        <Tooltip title={!concordou ? "Você possui pendências em sua documentação" : undefined}>
                            <Button
                                type="primary"
                                htmlType="button"
                                disabled={estaProcurandoDocumentos || !concordou}
                                onClick={() => !estaProcurandoDocumentos && concordou && props.onSucesso?.()}
                            >
                                {textoSalvar}
                            </Button>
                        </Tooltip>
                    </Flex>
                </React.Fragment>
            )}
        </>
    );
}
